import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import ProductListingResultsMessage from './components/ProductListingResultsMessage.jsx';

function mapStateToProps(state) {
  return {
    showingResultsLabel: state.listingPage.pagination.showingResultsLabel,
    productsPostXhrError: state.listingPage.pageSetup.xhrStatus.productsPostXhrError,
    deviceType: state.general.device.deviceType,
    categoryProductCount: state.listingPage.pagination.itemsNumberPerPage.categoryProductCount
  };
}

export default function initProductListingResultsMessage() {
  const ConnectedResultsMessage = connect(mapStateToProps)(ProductListingResultsMessage);
  const mountEl = document.querySelector('[data-component="list-page-results-message"]');

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedResultsMessage />
      </Provider>, mountEl
    );
  }
}
